import { Component, Input } from "@angular/core";

@Component({
    selector: "table-container",
    templateUrl: "./table-container.component.html",
    styleUrls: ["./table-container.component.scss"],
    standalone: false
})
export class TableContainerComponent {
  @Input()
  emptyText: string;

  @Input()
  showEmptyState: boolean;
}
